
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    paper: {
        padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100px', color: '#000', background: '#fff'
    },
    darkPaper: {
        padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100px', color: '#fff', background: '#545454'
    },
    mapContainer: {
        height: '85vh', width: '100%',
    },
    markerContainer: {
        position: 'absolute', transform: 'translate(-50%, -50%)', zIndex: 1, '&:hover': { zIndex: 2 }, 
    },
    pointer: {
        cursor: 'pointer',
    },
}));